<template>
  <div>
    <v-alert
      v-model="alert"
      :close-text="$t('close')"
      text
      type="success"
      outlined
      dismissible
      class="ma-4"
    >
      <div class="text-subtitle-2">振り込み人名義の頭に<span class="font-weight-bold" style="color: #FF8C71">{{ userId }}</span>を追記してください。</div>
      {{ billingPeriodDate }}の¥{{ billingTotal }}の支払いが確定しました。支払い期限は{{ paymentDueDate }}迄です。
    </v-alert>
  </div>
</template>

<script>
import { calcFortnight, formatDate } from "@/plugins/i18n";

export default {
  props: {
    currentFortnight: {
      type: Number,
      default: null
    },
    previousFortnight: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      alert: true,
      createdAt: null
    };
  },
  created() {
    this.createdAt = new Date();
    if (!this.isDisplayBilling()) {
      this.alert = false;
    }
  },
  methods: {
    calcFortnight,
    cFortnight(previousPeriod) {
      const date = new Date();

      if (previousPeriod) {
        date.setMonth(date.getMonth() - 1);
      }

      if (date.getDate() < 15) {
        const d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return formatDate(date, `yyyy/m/${d.getDate()}`);
      }

      date.setMonth(date.getMonth() + 1);
      return formatDate(date, "yyyy/m/15");
    },
    isDisplayBilling() {
      return this.nowDate % 15 === 1;
    },
    isFirstHalfPeriod() {
      return this.nowDate < 16;
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    userId() {
      return this.$store.state.user.id;
    },
    now() {
      return this.createdAt;
    },
    nowDate() {
      return this.now.getDate();
    },
    billingPeriodDate() {
      return calcFortnight(true, false);
    },
    billingTotal() {
      return this.previousFortnight;
    },
    paymentDueDate() {
      const paymentDueDate = this.isFirstHalfPeriod()
        ? new Date(this.now.getFullYear(), this.now.getMonth(), 15)
        : new Date(this.now.getFullYear(), this.now.getMonth() + 1, 0);
      return formatDate(paymentDueDate, "m/d");
    }
  }
};
</script>

<style lang="scss" scoped>
.product-header {
  &-payment-information {
    width: 100%;
    text-align: left;
    font-weight: bold;
  }

  &-left {
    text-align: center;

    &-top {
      font-weight: bold;
      font-size: 16px;
      color: #212121;
    }

    &-bottom {
      font-weight: 500;
      font-size: 15px;
      line-height: 12px;
      color: #212121;
      @media (max-width: 480px){
      font-size: 3.2vw;
      }
    }
  }

  &-right {
    text-align: center;
    &-top {
      font-weight: 500;
      font-size: 10px;
      color: #212121;
    }

    &-bottom {
      font-weight: bold;
      font-size: 16px;
      color: #212121;
      @media (max-width: 480px){
        font-size: 3.5vw;
      }
    }
  }

  &-chips {
    color: white;
    font-weight: 500;
    @media (max-width: 480px){
      font-size: 3vw;
    }
  }

  &-amount {
    color: #212121;
    font-weight: bold;
    font-size: 24px;
    @media (max-width: 480px){
        font-size: 5.5vw;
        font-weight: 900;
    }
    @media (max-width: 320px){
        font-size: 4.3vw;
    }
  }

  &-divider {
    border: 1px solid #00796b;
    transform: rotate(-63.43deg);
    width: 35px;
    height: 0;
    margin-top: 10px;
  }
}
</style>
